import React, { useEffect, useRef} from "react";
import propTypes from "prop-types";
import classNames from "classnames";
import { DefaultPageContainer as PageContainer } from "@layout";
import { Hero, BlogContainer } from "@organisms";
import gsap from "gsap";

const BlogIndexPage = ({ data }) => {
  const {
    hero,
    posts,
    meta,
    url,
    filters,
  } = data;

  return (
    <PageContainer meta={meta}>
      <Hero {...hero} />
      <BlogContainer
        posts={posts}
        url={url}
        filters={filters}
        {...meta}
      />
      <div className="h-[60rem] w-full absolute bg-soft-red-blue-gradient bottom-0 -z-10 opacity-20" />
    </PageContainer>
  );
};

BlogIndexPage.defaultProps = {};

BlogIndexPage.propTypes = {};

export default BlogIndexPage;
